import { TFunction } from "i18next";
import { GridRenderCellParams } from "@mui/x-data-grid-pro";

import { EventTypeEnum } from "shared/types";

import { CountTypeEnum } from "pages/Dashboard/components/constants";
import {
  ChartTimeGrouping,
  SmartGroupData,
} from "pages/Dashboard/components/SmartGroupsTable/types";

import { SchemaEntry } from "features/ui/MaterialTable";

/**
 * Context passed to column definitions for rendering headers and cells.
 */
export interface SmartGroupColumnContext {
  countType: CountTypeEnum;
  countLabel: string;
  chartLabel: string;
  chartKey: string;
  eventType: EventTypeEnum;
  filteredAccessor: string;
  allTimeAccessor: string;
  eventsPeriod: string;
  vehiclesPeriod: string;
  addProductionSuffix: boolean;
  isEventDate: boolean;
  showOnlyEventDateData: boolean;
  onToggleShowOnlyEventDateData: () => void;
  isSimplified: boolean;
  chartTimeGrouping: ChartTimeGrouping;
  maxFilteredValue: number;
  maxAllTimeValue: number;
  hoveredRowId: string | null;
  onOpenDetails: (id: string) => void;
  t: TFunction;
}

export interface ColumnHeaderRenderProps {
  context: SmartGroupColumnContext;
}

export interface ColumnCellRenderProps {
  params: GridRenderCellParams;
  row: SmartGroupData;
  context: SmartGroupColumnContext;
}

export interface SmartGroupColumnDefinition {
  id: string;
  getSchema: (context: SmartGroupColumnContext) => SchemaEntry;
  renderHeader: (props: ColumnHeaderRenderProps) => React.ReactNode;
  renderCell: (props: ColumnCellRenderProps) => React.ReactNode;
}

export enum SmartGroupColumnId {
  GROUP_NAME = "groupName",
  FILTERED_COUNT = "filteredCount",
  CHART = "chart",
  ALL_TIME_COUNT = "allTimeCount",
  PROJECT_ID = "projectID",
  ACTIONS = "actions",
}

export type ColumnOrderConfig = SmartGroupColumnId[];
